const _excluded = ["steps", "value", "caption"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { useId } from "@react-aria/utils";
import { cx } from "../../helpers/utils/cx";
const MIN_VALUE = 0;
const getColorClass = (activeStep, step) => {
  if (activeStep === step) {
    return "bg-active-action-secondary";
  }
  if (activeStep > step) {
    return "bg-action-primary";
  }
  return "bg-neutral-secondary-hard";
};
export function Stepper(_ref) {
  let {
      steps,
      value,
      caption
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const generatedId = useId();
  const labelId = rest["aria-labelledby"] ?? generatedId;
  if (steps < MIN_VALUE || value < MIN_VALUE) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx("w-full")
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: cx("flex w-full h-1 gap-1"),
    role: "progressbar",
    "aria-valuemin": MIN_VALUE,
    "aria-valuemax": steps,
    "aria-valuenow": value,
    "aria-busy": value < steps,
    "aria-labelledby": labelId
  }, rest), Array.from(Array(steps).keys()).map(step => /*#__PURE__*/React.createElement("div", {
    key: step,
    className: cx("relative h-full rounded transition-[background-color] ease-out", getColorClass(value, step)),
    style: {
      width: `${100 / steps}%`
    }
  }))), caption && /*#__PURE__*/React.createElement("div", {
    id: labelId,
    className: cx("bolt-font-body-s-accent text-center mt-2")
  }, caption));
}